import {
  ERROR_LOADING_ORGANIZATION,
  GET_ORGANIZATION_PROFILE,
  RESET_PROFILE_ACTION,
  START_LOADING_ORGANIZATION,
  STOP_LOADING_ORGANIZATION,
} from "./action-types";

import { Dispatch } from "redux";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
export const fetchOrganizationProfileAction =
  (organizationId: any) => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_ORGANIZATION });
    try {
      const { data } =
        await apiLibrary.OrganizationDirectory.getOrganizationProfile(
          organizationId
        );

      dispatch({
        type: GET_ORGANIZATION_PROFILE,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({ type: RESET_PROFILE_ACTION });
      dispatch({ type: ERROR_LOADING_ORGANIZATION });
      window.location.href = "/organizations/list";
    } finally {
      dispatch({ type: STOP_LOADING_ORGANIZATION });
    }
  };

export const organizationResetProfileAction = () => {
  return {
    type: RESET_PROFILE_ACTION,
  };
};
